import { ComponentType, SVGProps } from 'react';
import {
  IconCheckSquare,
  IconFileEdit,
  IconRefreshCcw,
  IconUpload,
  IconUser,
} from '@iwoca/icons';
import { TPermissions } from './PermissionsCell.types';

type TPermissionLabel = {
  key: keyof TPermissions;
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
};

export const PERMISSION_LABELS: TPermissionLabel[] = [
  { key: 'can_create_applications', label: 'Create apps', Icon: IconFileEdit },
  {
    key: 'can_upload_broker_documents',
    label: 'Upload docs',
    Icon: IconUpload,
  },
  {
    key: 'can_interact_with_offers',
    label: 'Interact with offers',
    Icon: IconCheckSquare,
  },
  {
    key: 'can_refresh_offers',
    label: 'Refresh offers',
    Icon: IconRefreshCcw,
  },
  {
    key: 'can_manage_account_users',
    label: 'Manage users',
    Icon: IconUser,
  },
];
